/**
 * Copy a string to the user's clipboard.
 *
 * Uses `navigator.clipboard.writeText` on modern browsers (Chrome 66+,
 * Safari 13.1+, Firefox 63+) and falls back to a hidden-textarea +
 * `document.execCommand('copy')` for HTTP / iframe / older browser
 * contexts where the async API is unavailable.
 *
 * Returns a promise that resolves to `true` if either path succeeded.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Fall through to the textarea fallback.
    }
  }

  if (typeof document === 'undefined') {
    return false;
  }

  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'absolute';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
